module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_download-cb8f61f1974b26d211e037d6d587de57.svg";